import React, { FC } from 'react';
import cn from 'classnames';
import { Pagination as Paginator } from 'antd';
import './styles.scss';

export type pageSizeType = 10 | 20 | 50 | 100;

interface IPagination {
  className?: string;
  disabled?: boolean;
  selectedPage?: number;
  showPageSize?: boolean;
  showJumper?: boolean;
  totalPages: number;
  variant?: 'dark' | 'light';
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
}

const Pagination: FC<IPagination> = ({
  className,
  disabled = false,
  selectedPage = 1,
  showPageSize = false,
  showJumper = false,
  totalPages,
  variant = 'light',
  onPageChange,
  onPageSizeChange,
}: IPagination) => {
  return (
    <div className={cn(`hbh-pagination-${variant}`, className)}>
      <Paginator
        disabled={disabled}
        current={selectedPage}
        showSizeChanger={showPageSize}
        showQuickJumper={showJumper}
        total={totalPages}
        onChange={onPageChange}
        onShowSizeChange={(_, size) => onPageSizeChange?.(size)}
      />
    </div>
  );
};

export default Pagination;
